define(["require", "exports", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, ko, log, tools, KendoUtils, UserContext) {
    "use strict";
    var CustomerPayments = /** @class */ (function () {
        function CustomerPayments(customerId, initGridCallback) {
            this.userCanViewCustomerPayments = ko.observable(UserContext.hasAccess("Admin,CustomerPayments.View,CustomerPayments.Edit,CustomerPayments.Delete"));
            this.userCanEditCustomerPayments = ko.observable(UserContext.hasAccess("Admin,CustomerPayments.Edit,CustomerPayments.Delete"));
            this.userCanDeleteCustomerPayments = ko.observable(UserContext.hasAccess("Admin,CustomerPayments.Delete"));
            this.userCanExportCustomerPayments = ko.observable(UserContext.hasAccess("Admin,CustomerPayments.Export"));
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            var self = this;
            self.customerId = customerId;
            self.isLookupDataLoaded = false;
            if (self.userCanViewCustomerPayments()) {
                tools.ajaxGet({
                    url: "/CustomerPayments/GetPaymentsLookupData",
                    data: { customerId: self.customerId },
                    success: function (data) {
                        if (data.Success) {
                            self.lookupLists = data.Data.lookupLists;
                            self.lookupLists = data.Data.lookupLists;
                            self.customerPaymentsGridStructure = self.lookupLists.GridStructures.PaymentsStructure;
                            self.initExportDataSource();
                            self.isLookupDataLoaded = true;
                            if (self.isInitGridRequested) {
                                self.initGrid();
                            }
                            if (initGridCallback) {
                                initGridCallback(self);
                            }
                        }
                        else {
                            log.error(data.Error);
                        }
                    }
                });
            }
        }
        CustomerPayments.prototype.initGrid = function () {
            if (this.userCanViewCustomerPayments()) {
                if (!this.isLookupDataLoaded) {
                    this.isInitGridRequested = true;
                }
                else {
                    this.initPayments();
                }
            }
        };
        CustomerPayments.prototype.initExportDataSource = function () {
            var self = this;
            self.customerPaymentsDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerPayments/GetPaymentsList",
                        type: "POST",
                        data: function () {
                            return {
                                customerId: self.customerId
                            };
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.customerPaymentsGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerPaymentsDataSource = new kendo.data.DataSource(self.customerPaymentsDataSourceOptions);
        };
        CustomerPayments.prototype.initPayments = function () {
            var self = this;
            var gridId = "divCustomerPaymentsTable";
            var columns = self.customerPaymentsGridStructure.columns;
            self.paymentsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: self.customerPaymentsDataSourceOptions,
                gridOptions: {
                    //toolbar: kendo.template($("#plans-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    sortable: true,
                    reorderable: true,
                    columnMenu: true,
                    scrollable: true,
                    height: 500,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "Payment",
                    title: "Payments",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false,
                controller: self
            };
            self.paymentsTable.initGrid(gridOptions);
        };
        return CustomerPayments;
    }());
    return CustomerPayments;
});
//# sourceMappingURL=customerPayments.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerPayments.js
// module id = 185
// module chunks = 2